var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 82.405,
    height: 72.79,
    viewBox: "0 0 82.405 72.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#e76f51;}.b{fill:#ff8a6c;}.c{fill:#ffb63b;}.d{fill:#fff;}.e{fill:#3b3735;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -28.001)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M123.552,51.843a6.868,6.868,0,0,1-9.713-9.713L107.709,36,72,71.708h46.7l12.361-12.361Z",
    transform: "translate(-59.639 -6.625)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M72,184.36h46.7L131.057,172l-50.816,4.12Z",
    transform: "translate(-59.639 -119.277)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M128,136.6,148.6,116l15.108,15.108-5.494,5.494Z",
    transform: "translate(-106.025 -72.891)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M152,156.48,168.389,140l11.079,11.079-5.311,5.4Z",
    transform: "translate(-125.905 -92.771)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M80.791,253.853a6.867,6.867,0,0,1,6.867-6.867V236H8v10.987A6.867,6.867,0,0,1,8,260.72v10.987H87.658V260.72A6.867,6.867,0,0,1,80.791,253.853Z",
    transform: "translate(-6.627 -172.29)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8,271.708H87.658V260.72a6.867,6.867,0,0,1,0-13.734V236Z",
    transform: "translate(-6.627 -172.29)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.734 63.709)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M384,260h2.747v5.494H384Z",
    transform: "translate(-331.81 -255.879)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M384,308h2.747v5.494H384Z",
    transform: "translate(-331.81 -295.638)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M384,356h2.747v5.494H384Z",
    transform: "translate(-331.81 -335.398)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M384,404h2.747v5.494H384Z",
    transform: "translate(-331.81 -375.157)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M80,236h2.747v5.494H80Z",
    transform: "translate(-80 -235.999)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M80,284h2.747v5.494H80Z",
    transform: "translate(-80 -275.759)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M80,332h2.747v5.494H80Z",
    transform: "translate(-80 -315.518)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M80,380h2.747v5.494H80Z",
    transform: "translate(-80 -355.278)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M80,428h2.747v2.747H80Z",
    transform: "translate(-80 -395.037)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M166.456,288.6V272.119a4.12,4.12,0,0,1-4.12-4.12H132.12a4.12,4.12,0,0,1-4.12,4.12V288.6a4.12,4.12,0,0,1,4.12,4.12h30.215A4.12,4.12,0,0,1,166.456,288.6Z",
    transform: "translate(-106.025 -198.796)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M176.962,300.023V287.2a3.379,3.379,0,0,1-3.531-3.2h-25.9A3.379,3.379,0,0,1,144,287.2v12.819a3.379,3.379,0,0,1,3.531,3.2h25.9A3.379,3.379,0,0,1,176.962,300.023Z",
    transform: "translate(-119.279 -212.049)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 28.001)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M81.031,76.07A1.373,1.373,0,0,0,82.4,74.7V63.709a1.373,1.373,0,0,0-1.373-1.373H63.75l8.643-8.643a1.373,1.373,0,0,0,0-1.942l-7.506-7.5a1.373,1.373,0,0,0-1.942,0,5.494,5.494,0,1,1-7.769-7.771,1.373,1.373,0,0,0,0-1.942L49.045,28.4a1.373,1.373,0,0,0-1.942,0L13.17,62.336H1.373A1.373,1.373,0,0,0,0,63.709V74.7A1.373,1.373,0,0,0,1.373,76.07a5.494,5.494,0,0,1,0,10.987A1.373,1.373,0,0,0,0,88.431V99.418a1.373,1.373,0,0,0,1.373,1.373H81.031A1.373,1.373,0,0,0,82.4,99.418V88.431a1.373,1.373,0,0,0-1.373-1.373,5.494,5.494,0,1,1,0-10.987ZM48.069,31.316l4.269,4.269a8.24,8.24,0,0,0,11.494,11.5l5.647,5.642-9.614,9.614H55.509l3.149-3.149a1.373,1.373,0,0,0,0-1.942L43.551,42.137a1.373,1.373,0,0,0-1.942,0l-20.2,20.2H17.054ZM25.294,62.336,42.576,45.05l13.17,13.166-4.12,4.12ZM79.658,89.69v8.354H68.671V92.551H65.924v5.494H16.481V96.671H13.734v1.373H2.747V89.69a8.24,8.24,0,0,0,0-16.253V65.083H13.734V69.2h2.747v-4.12H79.658v8.354a8.24,8.24,0,0,0,0,16.253Z",
    transform: "translate(0 -28.001)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M384.024,260h2.747v5.494h-2.747Z",
    transform: "translate(-318.096 -220.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M384.024,308h2.747v5.494h-2.747Z",
    transform: "translate(-318.096 -259.93)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M384.024,356h2.747v5.494h-2.747Z",
    transform: "translate(-318.096 -299.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M80.024,284h2.747v5.494H80.024Z",
    transform: "translate(-66.286 -240.05)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M80.024,332h2.747v5.494H80.024Z",
    transform: "translate(-66.286 -279.81)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M80.024,380h2.747v5.494H80.024Z",
    transform: "translate(-66.286 -319.569)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M159.829,264.119a2.747,2.747,0,0,1-2.747-2.747A1.373,1.373,0,0,0,155.709,260H125.494a1.373,1.373,0,0,0-1.373,1.373,2.747,2.747,0,0,1-2.747,2.747A1.373,1.373,0,0,0,120,265.493v16.481a1.374,1.374,0,0,0,1.373,1.373,2.747,2.747,0,0,1,2.747,2.747,1.373,1.373,0,0,0,1.373,1.373h30.215a1.373,1.373,0,0,0,1.373-1.373,2.747,2.747,0,0,1,2.747-2.747,1.373,1.373,0,0,0,1.373-1.373V265.493A1.373,1.373,0,0,0,159.829,264.119Zm-1.373,16.654a5.515,5.515,0,0,0-3.943,3.947H126.7a5.517,5.517,0,0,0-3.95-3.947v-14.08a5.517,5.517,0,0,0,3.95-3.947h27.816a5.516,5.516,0,0,0,3.943,3.947Z",
    transform: "translate(-99.399 -220.17)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickets);
export default __webpack_public_path__ + "static/media/tickets.8a76b26f83f830d90142559a6c695f9b.svg";
export { ForwardRef as ReactComponent };